import React, { useState, useEffect } from 'react';
import {
  Box, VStack, Text, Spinner, Center,
} from '@gluestack-ui/themed';

const MESSAGES = [
  'Mapping concept relationships...',
  'Sharpening virtual pencils...',
  'Analyzing pedagogical structure...',
  'Polishing the pens...',
  'Aligning with Bloom\'s Taxonomy...',
  'Looking for the key to the library...',
  'Optimizing task distribution...',
  'Convincing AI that 2+2 is usually 4...',
  'Constructing learning hierarchy...',
  'Wrangling stray semicolons...',
  'Synthesizing curriculum goals...',
  'Browsing the digital archives...',
  'Dusting off the ancient scrolls...',
  'Asking the rubber duck for advice...',
  'Calculating the meaning of life (it\'s taking a while)...',
  'Translating lecturer-speak to AI-speak...',
];

interface LoadingOverlayProps {
  isLoading: boolean;
  title?: string;
}

export const LoadingOverlay: React.FC<LoadingOverlayProps> = ({ isLoading, title = 'Processing' }) => {
  const [index, setIndex] = useState(0);

  useEffect(() => {
    let interval: NodeJS.Timeout;

    if (isLoading) {
      interval = setInterval(() => {
        setIndex((prev) => (prev + 1) % MESSAGES.length);
      }, 2500);
    } else {
      setIndex(0);
    }

    return () => {
      if (interval) clearInterval(interval);
    };
  }, [isLoading]);

  if (!isLoading) return null;

  return (
    <Center
      position="absolute"
      top={0}
      left={0}
      right={0}
      bottom={0}
      bg="rgba(255, 255, 255, 0.85)"
      zIndex={100}
    >
      <VStack
        space="lg"
        alignItems="center"
        p="$6"
        bg="$white"
        borderRadius="$lg"
        elevation={10}
        shadowColor="$black"
        shadowOpacity={0.1}
        shadowRadius={10}
        borderWidth={1}
        borderColor="$borderLight"
      >
        <Spinner size="large" color="$brandBase" />
        <VStack space="xs" alignItems="center">
          <Text fontWeight="bold" size="lg" color="$textHeading">{title}</Text>
          <Box h={40} justifyContent="center">
            <Text size="sm" color="$textSubtle" textAlign="center" italic>
              {MESSAGES[index]}
            </Text>
          </Box>
        </VStack>
      </VStack>
    </Center>
  );
};
